import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    Created for CS 1300 @ Brown University
  </footer>
)

export default Footer
